import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React, { forwardRef, useMemo } from "react";
import { Link, LinkProps } from "react-router-dom";
import { DrawerMenuItemSchema } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    listItemButton: {
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    listItemRoot: {
      padding: theme.spacing(2),
    },
    listItemIconRoot: {
      width: "1rem",
      height: "1rem",
      color: theme.palette.getContrastText(theme.palette.background.paper),
      flexShrink: "unset",
      marginRight: 0,
    },
    listItemTextRoot: {
      padding: 0,
    },
    listItemTextText: {
      color: theme.palette.getContrastText(theme.palette.background.paper),
    },
    activeListItemRoot: {
      backgroundColor: theme.palette.action.selected,
    },
    activeListItemIconRoot: {
      color: theme.palette.getContrastText(theme.palette.background.paper),
    },
    activeListItemTextText: {
      color: theme.palette.getContrastText(theme.palette.background.paper),
    },
  });

interface DrawerMenuItemProps extends WithStyles<typeof styles> {
  schema: DrawerMenuItemSchema;
  currentLocation: string;
}

export const DrawerMenuItemComponent = (props: DrawerMenuItemProps) => {
  const { schema, currentLocation, classes } = props;
  const { label, faIconName, linkUrl, activeLinkUrlRegex, onClick } = schema;

  const active = linkUrl && activeLinkUrlRegex && activeLinkUrlRegex.test(currentLocation);

  const listItemRootClass = classNames(classes.listItemRoot, active && classes.activeListItemRoot);
  const listItemIconRootClass = classNames(classes.listItemIconRoot, active && classes.activeListItemIconRoot);
  const listItemTextTextClass = classNames(classes.listItemTextText, active && classes.activeListItemTextText);

  // Use a Link component for the ListItem if a linkUrl is specified
  const ListItemLink = useMemo(
    () =>
      linkUrl
        ? forwardRef<any, Omit<LinkProps, "to">>((linkProps, ref) => <Link ref={ref} to={linkUrl} {...linkProps} />)
        : undefined,
    [linkUrl],
  );

  return (
    <ListItem
      button={true}
      disabled={schema.disabled}
      component={ListItemLink as any}
      onClick={onClick}
      classes={{ root: listItemRootClass, button: classes.listItemButton }}
    >
      <ListItemIcon>
        <FontAwesomeIcon icon={["fas", faIconName]} className={listItemIconRootClass} fixedWidth={true} />
      </ListItemIcon>
      <ListItemText classes={{ root: classes.listItemTextRoot, primary: listItemTextTextClass }} primary={label} />
    </ListItem>
  );
};

export const DrawerMenuItem = withStyles(styles)(DrawerMenuItemComponent);
